import { useEffect, useState, useRef } from "react";
// import TokenLogo from "../assets/dapp.svg";
// import eth from "../assets/eth.svg";
import {useSelector, useDispatch} from "react-redux";

import {
    loadBalances,
    transferTokens
} from "../store/interactions";

import config from "../config.json";

const Balance = ()=>{
    const [token1TransferAmount,settoken1TransferAmount] = useState(0);
    const [token2TransferAmount,settoken2TransferAmount] = useState(0);
    const [isDeposit , setisDeposit] = useState(true);

    const depositRef= useRef(null);
    const withdrawRef= useRef(null);

    const symbols = useSelector(state => state.tokens.symbols);
    const account = useSelector(state => state.provider.account);
    const tokens = useSelector( state => state.tokens.contracts);
    const exchange = useSelector(state => state.exchange.contract);
    const tokenBalances = useSelector(state => state.tokens.balances);
    const exchangeBalances = useSelector(state => state.exchange.balances);
    const provider = useSelector(state => state.provider.connection);
    const transferInProgress = useSelector(state => state.exchange.transferInProgress);

    const chainId = useSelector(state => state.provider.chainId);

    const dispatch = useDispatch();


    useEffect(()=>{        
        if(tokens[0] && tokens[1] && account && exchange ) loadBalances(dispatch,tokens,account, exchange);  
    },[tokens, account, exchange, transferInProgress])


    const amountHandler = async(e, token)=>{
        if(token.address == tokens[0].address){
            settoken1TransferAmount(e.target.value);
        }else{
            settoken2TransferAmount(e.target.value);
        }
    }

    const depositHandler = async(e,token)=>{
        e.preventDefault();

        if(token.address == tokens[0].address){
            transferTokens(dispatch, provider, exchange, 'Deposit', token, token1TransferAmount);
            settoken1TransferAmount(0);
        }else{
            transferTokens(dispatch, provider, exchange, 'Deposit', token, token2TransferAmount);
            settoken2TransferAmount(0);
        }
    }

    const withdrawHandler = async(e,token)=>{
        e.preventDefault();

        if(token.address == tokens[0].address){
            transferTokens(dispatch, provider, exchange, 'Withdraw', token, token1TransferAmount);
            settoken1TransferAmount(0);
        }else{
            transferTokens(dispatch, provider, exchange, 'Withdraw', token, token2TransferAmount);
            settoken2TransferAmount(0);
        }
    }

    const tabHandler= (e)=>{
        if(e.target.className !== depositRef.current.className){
            depositRef.current.className = 'tab';
            setisDeposit(false);
        }else{
            withdrawRef.current.className = 'tab';
            setisDeposit(true);
        }
        e.target.className = 'tab tab--active';

    }

    return(
        <div className="component exchange__transfers">
            <div className="component__header flex-between" >
            <a href="https://open-dex.gitbook.io/docs-willow/reference/beta/network" target='_blank' class="hover:text-sky-500 transition-colors duration-300 ease-in-out  ">
                <h2 title="Click">Balance</h2>
            </a>
                <div className="tabs">
                    <button onClick={tabHandler} ref={depositRef} className="tab tab--active">Deposit</button>
                    <button onClick={tabHandler} ref={withdrawRef} className="tab">Withdraw</button>
                </div>
            </div>
            
            {/* Deposit/Withdraw for token1 i.e epic token */}
            <div className="exchange__transfers--form">
    <div className="flex-between">
        {chainId && config[chainId] && symbols && symbols[0] && config[chainId][symbols[0]] ? (
            <>
                <p>
                    <small>Token (Trade)</small> <br />
                    <img
                        src={config[chainId][symbols[0]]['image']}
                        alt="TokenLogo"
                        className="max-w-8 max-h-6" // ใช้คลาส max-w-8 และ max-h-6 เพื่อกำหนดขนาดสูงสุดเป็น 8x6
                        />{' '}
                        {/* <a href="" target="_blank" title="Click to Address">
                            {symbols[0]}{' '} 
                        </a> */}
                        <a title="SmartContract" target="_blank" class="hover:text-sky-500 transition-colors duration-300 ease-in-out  " href={config[chainId][symbols[0]]['contract']}>{symbols[0]}</a>{' '} {/* สร้างลิงก์ไปยังหน้าอื่นโดยใช้ค่า contract */}
                </p>
                <p>
                    <small>Wallet</small> <br />{' '}
                    {tokenBalances && Number(tokenBalances[0]).toFixed(4)}{' '}
                </p>
                <p>
                    <small>Deposit</small> <br />{' '}
                   <b> {exchangeBalances && Number(exchangeBalances[0]).toFixed(4)} </b>
                </p>
            </>
        ) : (
            <p>Loading...</p>
        )}
    </div>
    {/* รายละเอียดอื่นๆ ของส่วนนี้ */}
    <form onSubmit = {isDeposit? (e)=> depositHandler(e,tokens[0]) : (e)=> withdrawHandler(e, tokens[0])} >
                    <label htmlFor="token0">{`${symbols && symbols[0]} Amount`}</label>
                    &nbsp;&nbsp;&nbsp;
                    <button className="reload-button" onClick={() => loadBalances(dispatch, tokens, account, exchange)} title="Click to ReloadBalances">
                     <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                     <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"/>
                     <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466"/>
                     </svg>
                   </button>
                    <input 
                    type="text" 
                    id="token0" 
                    placeholder="0.0000" 
                    maxlength="6" //
                    value={token1TransferAmount === 0? '': token1TransferAmount}
                    onChange={(e)=> amountHandler(e,tokens[0]) } />

                    <button className="button" type="submit">
                        {
                            isDeposit ?(
                                <span>Deposit</span>
                            ):(
                                <span>Withdraw</span>
                            )
                        }
                    </button>
    </form>
</div>



            <br></br>
            {/* <hr /> */}



            {/* Withdraw for token2 i.e mETH */}
            <div className="exchange__transfers--form">
    <div className="flex-between">
        {chainId && config[chainId] && symbols && symbols[1] && config[chainId][symbols[1]] ? (
            <>
                <p>
                    <small>Token (Pairs)</small> <br />
                    <img
                        src={config[chainId][symbols[1]]['image']}
                        alt="TokenLogo"
                        className="max-w-8 max-h-6" // ใช้คลาส max-w-8 และ max-h-6 เพื่อกำหนดขนาดสูงสุดเป็น 8x6
                        />{' '}
                    {/* {symbols[1]}{' '} */}
                    <a title="SmartContract" target="_blank" class="hover:text-sky-500 transition-colors duration-300 ease-in-out  " href={config[chainId][symbols[1]]['contract']}>{symbols[1]}</a>{' '} {/* สร้างลิงก์ไปยังหน้าอื่นโดยใช้ค่า contract */}
                </p>
                <p>
                    <small>Wallet</small> <br />{' '}
                    {tokenBalances && Number(tokenBalances[1]).toFixed(4)}{' '}
                </p>
                <p>
                    <small>Deposit</small> <br />{' '}
                   <b> {exchangeBalances && Number(exchangeBalances[1]).toFixed(4)} </b>
                </p>
            </>
        ) : (
            <p>Loading...</p>
        )}
    </div>
    {/* รายละเอียดอื่นๆ ของส่วนนี้ */}
    <form onSubmit = {isDeposit? (e)=> depositHandler(e,tokens[1]) : (e)=> withdrawHandler(e, tokens[1])}>
                    <label htmlFor="token1">{`${symbols && symbols[1]} Amount`}</label>
                    &nbsp;&nbsp;&nbsp;
                    <button className="reload-button" onClick={() => loadBalances(dispatch, tokens, account, exchange)} title="Click to ReloadBalances">
                     <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                     <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"/>
                     <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466"/>
                     </svg>
                   </button>
                    <input 
                    type="text" 
                    id="token1" 
                    placeholder="0.0000" 
                    maxlength="6" //
                    value={token2TransferAmount===0?'':token2TransferAmount}
                    onChange={(e)=> amountHandler(e,tokens[1]) }
                    />

                    <button className="button" type="submit">
                        {
                            isDeposit ?(
                                <span>Deposit</span>
                            ):(
                                <span>Withdraw</span>
                            )
                        }
                    </button>
    </form>
</div>


            <hr />



        </div>

    );
}

export default Balance;